// @core/api/endpoints/project/create_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProjectRequest,
  ProjectResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create project
 * Creates a new project with the specified methodology (Kanban, Scrum, or Waterfall). The caller becomes the project owner with full administrative rights.
 */
export async function CreateProject(
  data: CreateProjectRequest,
  options?: RequestOptions
): Promise<ProjectResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/projects`;
  const requestOptions = options;
  return client.post<ProjectResponse>(requestPath, data, requestOptions);
}
